<template>
  <span
    class="tw-bg-primary-100 tw-border tw-border-primary tw-text-neutral-900 tw-rounded-full tw-px-4 tw-py-2 tw-text-sm tw-font-bold"
  >
    <slot />
  </span>
</template>
